export default "__VITE_ASSET__efe749a3__"